// yyyyMMdd 형식을 Date 객체로 변환하는 함수
export const parseYYYYMMDD = (dateString: string | null | undefined): Date | null => {
  if (!dateString) return null;

  const trimmed = dateString.trim();
  if (trimmed.length !== 8) return null;

  const year = parseInt(trimmed.substring(0, 4), 10);
  const month = parseInt(trimmed.substring(4, 6), 10);
  const day = parseInt(trimmed.substring(6, 8), 10);

  if (isNaN(year) || isNaN(month) || isNaN(day)) return null;
  if (month < 1 || month > 12) return null;
  if (day < 1 || day > 31) return null;

  return new Date(year, month - 1, day);
};
